import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom, mergeMap } from 'rxjs/operators';
import { UserService } from '../../services/user.service';
import * as fromUser from './user.selectors';
import * as UserActions from './user.actions';
import { getUserProfile } from './user.selectors';
import { Transformation } from 'src/@utility/model-transformation';

@Injectable()
export class UserEffects {
  loadUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadUser),
      mergeMap((action) =>
        of(action).pipe(
          withLatestFrom(
            this.store.select(fromUser.getUser, { userId: action.userId })
          )
        )
      ),
      mergeMap(([action, data]) => {
        if (data) {
          return of(UserActions.dummyAction());
        }

        return this.userService.getUserNew(action.userId).pipe(
          map((response: any) => {
            return UserActions.loadUserSuccess({
              users: [response].map(Transformation['user']),
            });
          })
        );
      })
    );
  });

  loadUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadUsers),
      mergeMap((action) =>
        of(action).pipe(withLatestFrom(this.store.select(fromUser.getAllUser)))
      ),
      mergeMap(([action, data]) => {
        const userNotPresentInStore = action.userIds.filter(
          (userId) => !data.find((user) => user.id === userId)
        );
        if (userNotPresentInStore.length === 0) {
          return of(UserActions.dummyAction());
        }

        return this.userService.getUserMultipleNew(action.userIds).pipe(
          map((response: any) => {
            return UserActions.loadUserSuccess({
              users: Object.values(response),
            });
          })
        );
      })
    );
  });
  addOrUpdateUserProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.addOrUpdateUserProfile),
      switchMap((action) => {
        let data;
        this.store.select(getUserProfile).subscribe((ir) => {
          data = ir;
        });

        if (this.isEmptyObject(data)) {
          return this.userService.addProfile(action.userProfile).pipe(
            map((response) => {
              return UserActions.addOrUpdateUserProfileSuccess({
                userProfile: response,
              });
            })
          );
        } else {
          const editData = {
            id: data[0].id,
            userId: action.userProfile.userId,
            userSetting: action.userProfile.userSetting,
          };
          return this.userService.updateProfile(data[0].id, editData).pipe(
            map((response) => {
              return UserActions.addOrUpdateUserProfileSuccess({
                userProfile: response,
              });
            })
          );
        }
      })
    );
  });
  isEmptyObject(obj) {
    return obj && Object.keys(obj).length === 0;
  }

  loadUserProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadUserProfile),
      switchMap((action) => {
        return this.userService.getProfileByUserId(action.userId).pipe(
          map((response) => {
            return UserActions.loadUserProfileSuccess({
              userProfile: response,
            });
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private store: Store
  ) {}
}
